module.exports = __webpack_public_path__ + "assets/img/avatar_default.18d58a5b.png";